export const CERTIFICATION_DATA = [
    {
        id : "c1",
        certImg : "https://media.licdn.com/dms/image/C560BAQE88xCsONDULQ/company-logo_200_200/0/1618231291419?e=1691625600&v=beta&t=RR_Gk0ct4nZbMzbGHgAqCBa3OzEneb9B7fEVrx4h48Q",
        certTitle : "Developing Cross-Platform Web Apps with ASP.NET Core",
        certGiver : "Microsoft"
    },
    {
        id : "c2",
        certImg : "https://media.licdn.com/dms/image/C4E0BAQFgocdTGHthDA/company-logo_200_200/0/1581351014172?e=1691625600&v=beta&t=zdfDadg4RguuAsZqa7_W68IyJHm9XC_2kRk-5mn3kTo",
        certTitle : "Introduction to Cyber Security",
        certGiver : "Cisco Networking Academy"
    },
    {
        id : "c3",
        certImg : "https://media.licdn.com/dms/image/C4D0BAQGexnfBxeEG-g/company-logo_200_200/0/1608039227697?e=1691625600&v=beta&t=4v11u2I_4jvfRPnlFnbcnQEuArtUPM57X0lCdBtV6AM",
        certTitle : "Amazon Going-Cloud Native",
        certGiver : "Coursera"
    },
    {
        id : "c4",
        certImg : "https://pbs.twimg.com/profile_images/1360943119710253061/dWvmVVtD_400x400.jpg",
        certTitle : "Data Visualization",
        certGiver : "Global AI Hub"
    },
]

